import angular from "angular";

angular
    .module('app')
    .component('authModal', {
        template: require('./auth-modal.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&',
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.type = $ctrl.resolve.type;
    };

    $ctrl.setUser = function (user) {
        $ctrl.close({$value: user});
    };

    $ctrl.openResetPasswordForm = function () {
        $ctrl.type = 'reset-password';
    };

}
